import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Unauthorized({ message }) {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/');
        }, 3000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="mpa-unauthorized">
            <div className="mpa-unauthorized__card">
                <div className="mpa-unauthorized__icon">!</div>
                <h1 className="mpa-unauthorized__title">Access Denied</h1>
                <p className="text-muted mb-2">
                    {message || 'You do not have permission to access this page.'}
                </p>
                <p className="small text-muted mb-0">Redirecting to home…</p>
            </div>
        </div>
    );
}
